<template>
  <div>
    <HeroSecondary
      v-if="hero"
      v-bind="hero"
    />
    <div class="contact__main">
      <!--       <UnltdRepeatBG class="contact__bg" /> -->
      <ContactAddress
        :emails="emails"
        :phone="phone"
        :addresses="addresses"
      />
      <ContactSocial/>
    </div>
    <ContactBrandMoment/>
  </div>
</template>

<script>
  import HeroSecondary from './HeroSecondary';
  import ContactAddress from './ContactAddress';
  import ContactSocial from './ContactSocial';
  import ContactBrandMoment from './ContactBrandMoment';
  import UnltdRepeatBG from './UnltdRepeatBG';

  export default {
    components: {
      HeroSecondary,
      ContactSocial,
      UnltdRepeatBG,
      ContactAddress,
      ContactBrandMoment,
    },
    props: {
      emails: {
        type: Array,
        default: null,
      },
      phone: {
        type: String,
        default: null,
      },
      addresses: {
        type: Array,
        default: null,
      },
      hero: {
        type: Object,
        default: null,
      },
    },
    cleanProps({
      acf: {
        phone,
        emails,
        addresses,
        hero,
      },
    }) {
      return {
        hero,
        phone,
        addresses,
        emails: emails.map(({ email }) => email),
      };
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .contact__main {
    position: relative;
    z-index: 1;
    overflow: hidden;
  }

  // .contact__bg {
  //   position: absolute;
  //   left: 60%;
  //   width: 40%;
  //   fill: color(lightest-grey);

  //   @include breakpoint(phablet) {
  //     top: -20%;
  //     left: 75%;
  //     width: 30%;
  //     height: 140%;
  //   }
  // }
</style>
